var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "static-report" },
    [
      _c("Navbar"),
      _vm.isDataLoaded
        ? _c("div", { staticClass: "static-content" }, [
            _c("div", { staticClass: "flex-row ribbon" }, [
              _c("div", { staticClass: "flex-col flex-1" }, [
                _vm.shoulShowReport
                  ? _c("div", [
                      _vm._v(" Updated On: "),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.timeStamp) +
                            " " +
                            _vm._s(_vm.isReportEdited ? " (Edited)" : "")
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "mr-4" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.processSelection,
                              expression: "processSelection",
                            },
                          ],
                          staticClass: "flex-col flex-1",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.processSelection = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.onProcessChange,
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("All"),
                          ]),
                          _vm._l(_vm.distinctCategories, function (category) {
                            return _c(
                              "option",
                              { key: category, domProps: { value: category } },
                              [_vm._v(" " + _vm._s(category) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
              ]),
              _c("div", { staticClass: "flex-col flex-1 flex-align-center" }, [
                _c("div", { staticClass: "flex-row tab-toggler" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "flex-col",
                        "tab",
                        "tab-report",
                        _vm.shoulShowReport ? "active" : "",
                      ],
                      on: { click: () => (_vm.shoulShowReport = true) },
                    },
                    [_vm._v("Report")]
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        "flex-col",
                        "tab",
                        "tab-report",
                        !_vm.shoulShowReport ? "active" : "",
                      ],
                      on: { click: () => (_vm.shoulShowReport = false) },
                    },
                    [_vm._v("Line of sight")]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-1 flex-align-center" }, [
                _vm.shoulShowReport && _vm.hasEditAccess
                  ? _c(
                      "button",
                      { staticClass: "btn", on: { click: _vm.openEdit } },
                      [_vm._v(" " + _vm._s(_vm.$t("openInApplication")) + " ")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "flex-row page-content" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.shoulShowReport,
                      expression: "shoulShowReport",
                    },
                  ],
                },
                _vm._l(_vm.snoListResponse, function (data) {
                  return _c(
                    "div",
                    { key: data.asset.id },
                    [
                      _vm.hasAssetAccess(data.asset.id)
                        ? _c("ReportGrid", {
                            attrs: {
                              id: _vm.idPrefix + data.asset.id.toString(),
                              serialNumber: data.sno,
                              asset: { ...data.asset },
                              isNewUi: false,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.shoulShowReport,
                      expression: "!shoulShowReport",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-row" },
                    [
                      _c("adam-table", {
                        domProps: {
                          columns: _vm.columns,
                          data: _vm.filteredList,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }